(function($) {

  Drupal.behaviors.OneSpanTranslateStrings = {
    attach(context, settings) {
      Drupal.t("Select Content Type");
      Drupal.t("Content Type");
      Drupal.t("Select your area of interest...*");
      setTimeout(() => {
        if ($(".post-teaser").length) {
          bindClickEvent();
        }
      }, 10);
      if ($("body").hasClass("path-taxonomy-resource_categories")) {
        jQuery(
          ".menu--resource-center-menu .dropdown.lvl-0.first ul.dropdown-menu li.lvl-1"
        ).each(function() {
          var termID = jQuery('link[rel="edit-form"]')
            .attr("href")
            .split(/[/ ]+/)
            .slice(-2)
            .reverse()
            .pop();
          const link = jQuery(this).find("a");
          var termID = jQuery(link).attr(
            "href",
            `${jQuery(link).attr(
              "href"
            )}?field_resource_category_target_id[]=${termID}`
          );
        });
      }

      // Bind a click on the post-teaser.
      const bindClickEvent = () => {
        $(document).on('click', function (e) {
          const $target = $(e.target);
          const $teaser = $target.hasClass("post-teaser, .promoted-post") ? $target : $target.parents('.post-teaser, .promoted-post');

          // Make sure that categories are still clickable.
          if ($teaser.length && !$target.is('a') && !$target.parents('a').length) {
            e.stopPropagation();
            $teaser.find(".post-link")[0].click();
          }
        });
      }
      $("#edit-area-of-interest").multiselect();
      $("#edit-area-of-interest--2").multiselect();
      $("#edit-area-of-interest--3").multiselect();
      const $businessInterest = $("#edit-business-interest-c");
      const $businessInterestForm = $businessInterest.closest("form");
      const hasAreaOfInterestInSameForm = $businessInterestForm.find(
        "#edit-area-of-interest, #edit-area-of-interest--2, #edit-area-of-interest--3"
      ).length > 0;
      if ($businessInterest.length && hasAreaOfInterestInSameForm) {
        $businessInterest.multiselect();
      }
      $(
        ".form-item-area-of-interest .multiselect-native-select button.multiselect .multiselect-selected-text"
      ).text(Drupal.t("Select your area of interest...*"));
      if ($businessInterest.length && hasAreaOfInterestInSameForm) {
        $(
          ".form-item-business-interest__c .multiselect-native-select button.multiselect .multiselect-selected-text"
        ).text(Drupal.t("Select your area of interest...*"));
      }
    }
  };
})(jQuery);
